import { trpc } from '../../modules/trpc'

export const useConsumptionReports = (objectId: number) => {
	const { data, isFetching } = trpc.objects.getReports.useQuery(
		{
			objectId,
		},

		{
			enabled: objectId !== 0,
			staleTime: 5 * 60 * 1000, // 5 minutes
		}
	)

	return { data, isLoading: isFetching }
}
